module.exports = __webpack_public_path__ + "static/langchain-logo-03e729a6e75870150e8704708bdfd0c1.png";